import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import AnimalZakatTable from "./AnimalZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Animals_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice Zakat sur les animaux - Calculez la zakat sur les animaux avec précision et facilité";
const DESCRIPTION =
  "Calculatrice Zakat sur les animaux - Calculez la zakat sur les animaux avec précision et facilité pour effectuer vos calculs islamiques de facon claire et rapide. Outil pratique pour verifier vos donnees et obtenir un resultat fiable en ligne.";
const KEYWORDS =
  "zakat sur les animaux la zakat sur les animaux avec précision et facilité, calculatrice zakat sur les animaux la zakat sur les animaux avec précision et facilité, calcul en ligne, zakat, heritage, calcul islamique, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/animals-zakat/";
const apiEndpoint = `${SERVER_URL}/${Animals_Zakat_EndPoint}`;
function AnimalZakatCalculator() {
  const [camelCount, setCamelCount] = useState(0);
  const [cowCount, setCowCount] = useState(0);
  const [sheepCount, setSheepCount] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleCamelCountChange = (event) => {
    setCamelCount(event.target.value);
  };
  const handleCowCountChange = (event) => {
    setCowCount(event.target.value);
  };
  const handleSheepCountChange = (event) => {
    setSheepCount(event.target.value);
  };
  const calculateAnimalsZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ camelCount, cowCount, sheepCount }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>Calculez la zakat sur les animaux</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                La calculatrice zakat sur les animaux est un outil utilisé pour calculer le montant de la zakat due sur les animaux selon les règles religieuses en Islam. Cette calculatrice calcule le montant financier qui doit être payé comme zakat sur les animaux tels que les chameaux, les bovins et les ovins.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Zakat sur les animaux
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="camelCount" className="form-label ms-2">
                      Nombre de chameaux {" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="camelCount"
                    value={camelCount}
                    onChange={handleCamelCountChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="cowCount" className="form-label ms-2">
                      Nombre de bovins {" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="cowCount"
                    value={cowCount}
                    onChange={handleCowCountChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="sheepCount" className="form-label ms-2">
                      Nombre d'ovins {" "}
                    </label>
                  </b>
                  <input
                    type="number"
                    id="sheepCount"
                    value={sheepCount}
                    onChange={handleSheepCountChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                  />
                </div>
                <br/>
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateAnimalsZakat}
                >
                  Calculer
                </button>
              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Erreur :</u>
                    </b>{" "}
                    Veuillez remplir tous les champs correctement.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        Résultats:{" "}
                      </div>
                    </h4>
                    <hr />
                    <AnimalZakatTable result={result}></AnimalZakatTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Description de la calculatrice zakat sur les animaux
              </div>
              <div className="info-section-body">
                <u>
                  <b> Calculatrice zakat sur les animaux </b>{" "}
                </u>{" "}
                <br/>
                La calculatrice analyse le nombre d'animaux selon les critères définis dans la loi islamique, tels que le nombre minimum et maximum d'animaux, et calcule le montant de la zakat due et fournit une description pour chaque catégorie d'animaux et le montant requis selon cette catégorie.
                <br/>
                En utilisant la calculatrice, l'utilisateur peut entrer le nombre de chameaux, de bovins et d'ovins qu'il possède, puis le montant de la zakat due est calculé selon les règles et critères religieux. Une description détaillée de chaque catégorie d'animaux et du montant à payer est fournie, aidant l'utilisateur à comprendre les règles et exigences relatives à la zakat sur les animaux.
                <br/>
                En utilisant la calculatrice zakat sur les animaux, il devient facile et pratique pour les musulmans de calculer et de déterminer le montant de la zakat due sur leurs animaux et de remplir leurs obligations religieuses.
                <br/>
                <hr />
                <b>Dernière révision : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AnimalZakatCalculator;
